import Link from 'next/link';
import Icon from '@/components/ui/AppIcon';

export default function Footer() {
  const currentYear = 2026;

  const footerLinks = [
    { id: 'footer_markets', label: 'Markets', href: '/markets' },
    { id: 'footer_news', label: 'News', href: '/news' },
    { id: 'footer_about', label: 'About', href: 'https://www.moneymine.in/' },
    { id: 'footer_contact', label: 'Contact', href: 'mailto:help@moneymine.com' },
    { id: 'footer_privacy', label: 'Privacy', href: '#' },
    { id: 'footer_terms', label: 'Terms', href: '#' },
  ];

  const socialLinks = [
    { id: 'social_twitter', name: 'Twitter', icon: 'AtSymbolIcon', href: '#' },
    { id: 'social_linkedin', name: 'LinkedIn', icon: 'LinkIcon', href: '#' },
    { id: 'social_rss', name: 'RSS', icon: 'RssIcon', href: '#' },
  ];

  return (
    <footer className="bg-card border-t border-border mt-20">
      <div className="container mx-auto px-4 py-12 max-w-7xl">
        {/* Single Row Layout */}
        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          {/* Logo & Copyright */}
          <div className="flex items-center gap-6">
            <Link href="/homepage" className="flex items-center gap-2">
              <div className="w-8 h-8 bg-gradient-to-br from-primary to-accent rounded-lg flex items-center justify-center">
                <span className="text-base font-bold text-gray-900">M</span>
              </div>
              <span className="text-lg font-bold text-foreground font-display">
                MoneyMine
              </span>
            </Link>
            <span className="text-sm text-muted-foreground">
              © {currentYear}
            </span>
          </div>

          {/* Footer Links */}
          <div className="flex flex-wrap items-center justify-center gap-6">
            {footerLinks.map((link) => (
              <Link
                key={link.id}
                href={link.href}
                className="text-sm text-muted-foreground hover:text-primary transition-colors"
              >
                {link.label}
              </Link>
            ))}
          </div>

          {/* Social Icons */}
          <div className="flex items-center gap-4">
            {socialLinks.map((social) => (
              <a
                key={social.id}
                href={social.href}
                target="_blank"
                rel="noopener noreferrer"
                className="p-2 hover:bg-muted rounded-lg transition-colors"
                aria-label={social.name}
              >
                <Icon
                  name={social.icon as any}
                  size={18}
                  className="text-muted-foreground hover:text-primary transition-colors"
                />
              </a>
            ))}
          </div>
        </div>

        {/* Disclaimer */}
        <div className="mt-8 pt-6 border-t border-border text-center">
          <p className="text-xs text-muted-foreground leading-relaxed max-w-4xl mx-auto mb-4">
            Disclaimer: MoneyMine aggregates financial data from multiple public sources. 
            Information provided is for educational purposes only and should not be considered 
            as financial advice. Always consult with a qualified financial advisor before making 
            investment decisions. Market data may be delayed.
          </p>
          <div className="flex items-center justify-center gap-2 text-sm text-muted-foreground">
            <Icon name="QuestionMarkCircleIcon" size={18} className="text-primary" />
            <span>Have questions or need support?</span>
            <a
              href="mailto:help@moneymine.com"
              className="text-primary hover:underline font-semibold"
            >
              help@moneymine.com
            </a>
          </div>
          <p className="text-xs text-muted-foreground mt-2">
            Read more at:{' '}
            <a
              href="https://www.moneymine.in/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-primary hover:underline"
            >
              https://www.moneymine.in/
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}